import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'red-trash-can-button',
    templateUrl: './red-trash-can-button.component.html',
    styleUrls: ['./red-trash-can-button.component.scss'],
    standalone: false
})
export class RedTrashCanButtonComponent implements OnInit {
  @Input() class = ''; 

  constructor() { }

  ngOnInit(): void {
  }

}
